// ============================================================================
// ui/liquid-glass.js — the SVG refraction filter behind `.wd-liquid-glass`
// ============================================================================
// PORTED FROM: Master-Bot/Agent-Shopify-Files/assets/bb-hotspot.js (injectFilter).
// That file is the source of truth for the look; this is the same filter, because
// this bundle is served cross-origin from Cloudflare Pages and can't reach the
// theme's script.
//
// This is what makes the glass read as CLEAR rather than frosted, and it's the
// whole trick behind the blog's hotspot cards: the CSS variant that references
// this filter drops the blur to 1px and refracts the backdrop through fractal
// noise instead. Frosting hides what's behind it; refraction bends it — you still
// see the room, just displaced, which is what real glass does.
//
// Chromium applies url() inside backdrop-filter; Safari and the rest ignore it
// and fall back to the plain frosted blur in the base rule. Both are fine, the
// @supports test in the CSS picks.
//
// NOTE the id is `wd-liquid`, NOT the theme's `bbhs-liquid`: the Weight Designer
// mounts on a Shopify page that may ALSO have blog hotspots on it, and two
// identical filter ids in one document is a collision waiting to happen.
// ============================================================================

const FILTER_ID = 'wd-liquid';

/**
 * Inject the displacement filter once per document. Safe to call repeatedly.
 * No-ops outside a browser.
 */
export function injectLiquidFilter() {
  if (typeof document === 'undefined') return;
  if (document.getElementById(FILTER_ID)) return;
  const host = document.createElement('div');
  host.setAttribute('aria-hidden', 'true');
  host.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
  // Large, smooth organic noise (low baseFrequency) → clean refraction, not busy.
  // STATIC (no <animate>): like real glass the distortion holds still while the
  // card is still, and shifts only when the card moves, because the backdrop
  // region behind it changes. `scale` is the warp strength.
  host.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" width="0" height="0">' +
    `<filter id="${FILTER_ID}" x="-35%" y="-35%" width="170%" height="170%" color-interpolation-filters="sRGB">` +
    '<feTurbulence type="fractalNoise" baseFrequency="0.005 0.007" numOctaves="2" seed="7" result="n"/>' +
    '<feGaussianBlur in="n" stdDeviation="2.4" result="nb"/>' +
    '<feDisplacementMap in="SourceGraphic" in2="nb" scale="46" xChannelSelector="R" yChannelSelector="G"/>' +
    '</filter></svg>';
  document.body.appendChild(host);
}
